import React from 'react'
import axios from 'axios'

import Button from '../Form/Button'

import '../Home/Home.css'

export default class Ai extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            ficha: {
                processo: this.props.match.params.id, user: localStorage.nome, ai: '', data: '', aiNumero: '',
                autuado: '', inscricao: '', anuidades: '', multa: '',
                parcelamento: '', descricao: '', norma: '', notificacao: ''
            }
        }
    }

    componentDidMount() {
        const id = this.props.match.params.id
        var paf = this.props.location.search.slice(1)
        const ficha = { ...this.state.ficha }
        ficha.tipo = paf
        this.setState({ ficha })
        const url = `/api/ficha/processo/${id}`
        axios(url)
            .then(resp => {
                this.setState({ list: resp.data })
            })
            .catch(error => {
                alert(error.response.data)
            }
            )
    }

    updateField(event) {
        const ficha = { ...this.state.ficha }
        ficha[event.target.name] = event.target.value
        this.setState({ ficha })
    }

    save(e) {
        e.preventDefault()
        const url = '/api/processo/ai'
        const ficha = this.state.ficha
        axios.post(url, ficha)
            .then(res => {
                alert(res.data)
                if(this.state.ficha.tipo == 'paf') {
                    window.location = `/documentosPaf/${this.props.match.params.id}`
                } else {
                    window.location = `/documentos/${this.props.match.params.id}`
                }
            })
            .catch(error => {
                alert(error.response.data)
            })
    }

    render() {
        const id = this.props.match.params.id
        return (
            <React.Fragment>
                <div className="container form-group mx-auto row mt-3">
                    <label className="col-4">Infração:</label>
                    <div className="col-8 col-md-4">
                        <select className="custom-select"
                            name="ai"
                            onChange={e => this.updateField(e)} >
                            <option value=""></option>
                            <option value="Debito">Débitos com obrigações pecuniárias</option>
                            <option value="Branco">Em branco</option>
                        </select>
                    </div>
                </div>
                <div className="container">
                    {this.renderAis()}
                </div>
                <Button onClick={e => this.save(e)} />
            </React.Fragment>
        )
    }

    renderAis() {
        if (this.state.ficha.ai == "Debito") {
            return (
                <React.Fragment>
                    <div className="form-group row mt-3 text-left">
                        <label className="col-3 col-md-2">Data:</label>
                        <div className="col-9 col-md-2 mb-3">
                            <input type="date" className="form-control"
                                onChange={e => this.updateField(e)}
                                name="data" />
                        </div>
                    </div>
                    <div className="form-group row mt-3 text-left">
                        <label className="col-3 col-md-2">Número do A.I.:</label>
                        <div className="col-9 col-md-2 mb-3">
                            <input type="text" className="form-control"
                                onChange={e => this.updateField(e)}
                                name="aiNumero" />
                        </div>
                        <label className="col-3 col-md-2">Autuado:</label>
                        <div className="col-9 col-md-2 mb-3">
                            <input type="text" className="form-control"
                                onChange={e => this.updateField(e)}
                                name="autuado" />
                        </div>
                        <label className="col-3 col-md-2">Nº de Inscrição:</label>
                        <div className="col-9 col-md-2 mb-3">
                            <input type="text" className="form-control"
                                onChange={e => this.updateField(e)}
                                name="inscricao" />
                        </div>
                        <label className="col-3 col-md-2">Anuidades:</label>
                        <div className="col-9 col-md-10 mb-3">
                            <input type="text" className="form-control"
                                onChange={e => this.updateField(e)} placeholder="Separar por vírgulas"
                                name="anuidades" />
                        </div>
                        <label className="col-3 col-md-2">Multa Eleitoral:</label>
                        <div className="col-9 col-md-4 mb-3">
                            <input type="text" className="form-control"
                                onChange={e => this.updateField(e)} placeholder="Separar por vírgulas"
                                name="multa" />
                        </div>
                        <label className="col-3 col-md-2">Parcelamento das Anuidades:</label>
                        <div className="col-9 col-md-4 mb-3">
                            <input type="text" className="form-control"
                                onChange={e => this.updateField(e)} placeholder="Separar por vírgulas"
                                name="parcelamento" />
                        </div>
                    </div>
                </React.Fragment>
            )
        }
        if (this.state.ficha.ai == "Branco") {
            return (
                <React.Fragment>
                    <div className="form-group row mt-3 text-left">
                        <label className="col-3 col-md-2">Data:</label>
                        <div className="col-9 col-md-2 mb-3">
                            <input type="date" className="form-control"
                                onChange={e => this.updateField(e)}
                                name="data" />
                        </div>
                    </div>
                    <div className="form-group row mt-3 text-left">
                        <label className="col-3 col-md-2">Número do A.I.:</label>
                        <div className="col-9 col-md-2 mb-3">
                            <input type="text" className="form-control"
                                onChange={e => this.updateField(e)}
                                name="aiNumero" />
                        </div>
                        <label className="col-3 col-md-2">Autuado:</label>
                        <div className="col-9 col-md-2 mb-3">
                            <input type="text" className="form-control"
                                onChange={e => this.updateField(e)}
                                name="autuado" />
                        </div>
                        <label className="col-3 col-md-2">Nº de Inscrição:</label>
                        <div className="col-9 col-md-2 mb-3">
                            <input type="text" className="form-control"
                                onChange={e => this.updateField(e)}
                                name="inscricao" />
                        </div>
                        <label className="col-3 col-md-2">Descrição:</label>
                        <div className="col-9 col-md-10 mb-3">
                            <textarea type="textarea" rows="3" className="form-control"
                                onChange={e => this.updateField(e)}
                                name="descricao" />
                        </div>
                        <label className="col-3 col-md-2">Norma Infrigida:</label>
                        <div className="col-9 col-md-10 mb-3">
                            <textarea type="textarea" rows="3" className="form-control"
                                onChange={e => this.updateField(e)}
                                name="norma" />
                        </div>
                        <label className="col-3 col-md-2">Notificação:</label>
                        <div className="col-9 col-md-10 mb-3">
                            <textarea type="textarea" rows="3" className="form-control"
                                onChange={e => this.updateField(e)}
                                name="notificacao" />
                        </div>
                    </div>
                </React.Fragment>
            )
        }
    }
}